<template>
  <div class="home">
    <shell>
      <template v-slot:default>
        <div class="lg:w-full container m-auto">
          <div class="w-full lg:w-1/2 m-auto relative">
            <div class="px-2">
              <div class="m-auto">
                <div class="w-full">
                  <div>
                    <div class="my-4 py-4 rounded text-gray-darker">
                      Import from <router-link to="/import-keep">Google Keep</router-link>,
                      <!-- <router-link to="/import-boa">Bank of America</router-link>, -->
                      <router-link to="/import-pinboard">Pinboard</router-link>,
                      or
                      <router-link to="/import-csv">your own CSV</router-link>
                    </div>

                  </div>
                  

                  <div class="pb-4 text-lg font-bold">Imports</div>
                  <div v-if="imports.length === 0">
                    <div class="my-4 p-4 bg-gray-lighter rounded text-gray-darker">
                      No imports yet...
                    </div>

                  </div>

                  <router-link v-else v-for="i in imports" class="bg-white mb-4 p-4 rounded block flex justify-between items-center no-underline" :to="'/imports/' + i.short_id">
                    <div><span>{{i.num_records}} notes</span> from <strong>{{({KEEP: 'Google Keep'})[i.type]}}</strong> <span> on {{renderDate(i.created_at)}}</span></div>
                    <font-awesome-icon size="lg" class="text-black" icon="chevron-right" color="black" />

                  </router-link>
                </div>
              </div>
            </div>
          </div>
        </div>
      </template>
    </shell>
  </div>
</template>
<script>
 import {DateTime} from 'luxon';
 import {mapState, mapActions} from 'vuex';
 import eventBus from '@/eventBus';
 import Shell from '@/components/Shell';

 import api from '@/api'

 export default {
   name: 'imports',
   props: {
     path: {
       type: String,
       default: ''
     },
   },

   data () {
     return {
       imports: [],
       error: ''
     }
   },

   components: {Shell},

   computed: {
     ...mapState({
       member: state => state.member,
     }),
   },

   async created () {
     const {res, err} = (await api.getImports())

     if (err) {
       this.error = err.response.data
     }

     this.imports = res
   },

   methods: {
     renderDate(d) {
       return DateTime.fromISO(d).toFormat('LLL dd, yyyy t')
     },

     
   },
 }
</script>

<style scoped>
 
</style>


